module.exports = __webpack_public_path__ + "static/img/poster1.cab66be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poster1.png
// module id = 870
// module chunks = 32